module.exports = __webpack_public_path__ + "static/media/AI.629cb43e.svg";